import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Consultar Ticket"}>
                                <Button
                                    disabled={row.codEstadoProceso == "06" ? true : false}
                                    type="primary"
                                    icon="search"
                                    size={"small"}
                                    loading={props.loadingTicket}
                                    onClick={() => props.handleConsultaTicekt(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title={"Descargar Sire"}>
                                <Button
                                    disabled={row.codEstadoProceso == "06" ? false : true}
                                    loading={props.loadingTxt}
                                    type={"success"}
                                    icon={"file-done"}
                                    size={"small"}
                                    onClick={() => props.onDownloadSire(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Periodo Tributario',
                    dataIndex: 'periodoTributario',
                    key: 'periodoTributario',
                    sorter: true
                },
                {
                    title: 'numero Ticket',
                    dataIndex: 'numeroTicket',
                    key: 'numeroTicket',
                    sorter: true
                },
                {
                    title: 'Fecha Carga Importacion',
                    dataIndex: 'fechaCargaImportacionStr',
                    key: 'fechaCargaImportacionStr',
                    sorter: true
                },
                {
                    title: 'Fecha Inicio Proceso',
                    dataIndex: 'fechaInicioProcesoStr',
                    key: 'fechaInicioProcesoStr',
                    sorter: true
                },
                {
                    title: 'Codigo Proceso',
                    dataIndex: 'codigoProceso',
                    key: 'codigoProceso',
                    sorter: true
                },
                {
                    title: 'Descripcion Proceso',
                    dataIndex: 'desProceso',
                    key: 'desProceso',
                    sorter: true
                },
                {
                    title: 'Nombre Archivo Importacion',
                    dataIndex: 'nomArchivoImportacion',
                    key: 'nomArchivoImportacion',
                    sorter: true
                },
                {
                    title: 'Nombre Archivo Contenido',
                    dataIndex: 'nombreArchivoContenido',
                    key: 'nombreArchivoContenido',
                    sorter: true
                },
                {
                    title: 'Estado',
                    dataIndex: 'codEstadoProceso',
                    key: 'codEstadoProceso',
                    align: 'center',
                    width: "90px",
                    render: (value) => {
                        return (<div className="custom-options" >
                            <Tag color={value == "06" ? "green" : "red"}>{value == "06" ? "Terminado" : "En proceso"}</Tag>
                        </div>)
                    }
                }
            ]}
        />
    );
}